import axios from "axios";
import * as Sentry from "@sentry/react";

// Statuses the session guard (401) and the access rules (403) already handle:
// the student is signed out or sees a message, and nothing is left for us to fix.
const HANDLED_STATUSES = [401, 403];

// True for a failure that is not a defect of the app: the request never got an
// answer (offline, blocked, closed with the tab, or replaced by a newer
// request), or the server refused it for a reason the app already shows.
// A TypeError thrown inside a .then() is not an axios error, so it is still
// reported.
export const isExpectedRequestFailure = (err) => {
  if (!err) return false;
  if (axios.isCancel(err) || err.message === "Cancelled due to new request") {
    return true;
  }
  if (!err.isAxiosError) return false;
  if (!err.response) return true;
  return HANDLED_STATUSES.includes(err.response.status);
};

/**
 * Reports a failed Courses request as an info event. Failures that are not a
 * defect (see isExpectedRequestFailure) are skipped. The status and the server
 * message go with the event, so that the event shows which request failed.
 */
export const reportRequestError = (message, err, extra = {}) => {
  if (isExpectedRequestFailure(err)) return;
  Sentry.captureEvent({
    message,
    level: "info",
    extra: {
      ...extra,
      status: err?.response?.status,
      responseMsg: err?.response?.data?.msg,
    },
  });
};

export default reportRequestError;
